export enum MediaTypePreviewIconType {
  POST = 'post',
  STORY = 'story',
  BOTH = 'both',
}

export interface MediaTypePreviewIconProps {
  type: MediaTypePreviewIconType;
  className?: string;
}
